<button class="close" mat-button (click)="onClickNo()">X</button>
<h3 mat-dialog-title>{{action | uppercase}}</h3>
<mat-dialog-content>
    <h4><b>Are you sure to {{action}} this {{type}} ?</b></h4>
</mat-dialog-content>
<div style="float: right;">
    <button mat-raised-button style="height: 2.2rem;" (click)="onClickYes()" color="warn" *ngIf="action == 'delete'">Delete</button>
    <button mat-raised-button style="height: 2.2rem;" (click)="onClickCreateClone()" color="primary" *ngIf="action == 'clone'">Clone</button>
</div>
<!-- <mat-dialog-actions>
    <button mat-raised-button style="float: left;" (click)="onClickNo()" color="primary">Cancel</button>
    <button mat-raised-button style="float: right;" (click)="onClickYes()" color="warn">Delete</button>
    <div style="float: right;">
        <button  (click)="onClickYes()">Delete</button>
    </div>
    
  </mat-dialog-actions> -->
